import { Platform, NavController, AlertController, LoadingController, ToastController, PopoverController } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';
import { RestService } from '../../services/rest.service';
import { UtilService } from '../../services/util.service';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer} from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';
import { OptionSubscribeComponent } from 'src/app/popover/option-subscribe/option-subscribe.component';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}
  transform(url) {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Component({
  selector: 'app-browse',
  templateUrl: 'browse.page.html',
  styleUrls: ['browse.page.scss'],
})

export class BrowsePage implements OnInit {

  user: any;
  public slug: string;
  public url: string;
  isMobile = false;
  searchTop: any;
  searchSection: any;
  helpFocus: boolean;
  showOverSearch: boolean;
  loadMostWanted: boolean;
  userSubscriptions: any;
  due_date: any;
  availableSubscriptions: any;
  futureEmail: any;
  coupon: any;
  refCode: string;
  showSubscribe: boolean = true;


  constructor(
    public rest: RestService,
    public util: UtilService,
    public platform: Platform,
    private route: ActivatedRoute,
    private domSanitizer: DomSanitizer,
    public navCtrl: NavController,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public toastCtrl: ToastController,
    public location:Location,
    private translate: TranslateService,
    public popoverCtrl: PopoverController
  ) {
    this.rest.getStorage('user').then((val) => {
      this.user = val;
    })
  }

  async ngOnInit() {

    this.route.params.subscribe(params => {
      this.slug = params['slug'].split('&')[0];
      this.url = "https://blog.louderband.com/" + this.slug;

      const exceptions = ['tycbitelperu', 'landing-page2', 'landing-page-suscripciones-cuenta-pro', 'politicas-de-privacidad','terminos-y-condiciones', 'delete-my-account', 'suscripcion-cursos'];

      if (exceptions.includes(this.slug)){
        this.showSubscribe = false;
      }

      // Show if the banner is the user msisdn is louderband
      if (this.user && this.user.msisdn == 'louderband') {
        this.showSubscribe = true;
      }

      console.log('From browse:', this.url);
    });

   }

   gotoOldApp(view?) {
    console.log(view);

    if (view) {
      this.navCtrl.navigateForward(view);
    } else {
      window.open('https://louderband.com/', '_self');
    }
  }

  outData2(ev) {
    if (ev && ev.blur) {
      this.showOverSearch = false;
      this.searchTop = null;
      this.helpFocus = false;
    }
  }

   outData(ev) {
    // console.log('From Home:', ev);

    if (ev && ev.home) {
      let url = '/home';
      this.navCtrl.navigateForward(url);
    }

    if (ev && ev.referred) {
      let url = '/referred';
      this.navCtrl.navigateRoot(url);
    }

    if (ev && ev.focus) {
      this.showOverSearch = true;
      if (ev.search === '') {
        this.searchTop = '';
      }
      setTimeout(() => {
        this.helpFocus = true;
      }, 1800);
    }

    if (ev && ev.login) {
      // this.openLogin();
      this.navCtrl.navigateRoot('/login')
    }

    if (ev && ev.old) {
      // this.navCtrl.navigateRoot('/registro')
      this.gotoOldApp(ev.view);
    }


    if(ev && ev.search) {
      console.log('From Home', 'Search term:', ev.search);
      this.searchTop = ev.search;
    }

    if(ev && ev.search_section) {
      console.log('From Home', 'Search section:', ev.search_section);
      this.searchSection = ev.search_section;
      // this.rerender();
    }

    if (ev && typeof ev.isMobile === 'boolean') {
      // console.log(ev);
      this.isMobile = ev.isMobile;
    }

  }

  shouldDisableSubscribe(){
    if (!this.userSubscriptions || this.userSubscriptions.length == 0){
      return false;
    }

    return this.due_date ? true : false;
  }

  ionViewDidEnter() {
    if (this.user) {
      this.getSubscriptions();
    } else {
      this.rest.getStorage('user').then((val) => {
        this.user = val;
        console.log(val);
      })
      setTimeout(() => {
        this.getSubscriptions();
      }, 400);
    }
  }

  goSubscribe() {
    if (!this.user) {
      this.optionSubscribe();
    } else if (this.user && this.user.msisdn && this.user.msisdn == 'louderband') {
      window.location.replace('http://mps.bitel.com.pe/MPS/landing/louderband_daily');
    } else {
      this.optionSubscribe();
    }
  }

  async getAvailableSubscriptions() {
    let loading = await this.loadingCtrl.create({});
    loading.present();



    this.rest._get('subscription/list').subscribe(async (response) => {
      const res: any = response.body;
      this.availableSubscriptions = res;

      console.log('available subscriptions', res);
      loading.dismiss();
    }, (error) => {
      loading.dismiss();
      console.error('error subscriptions: ', error);
    });
  }

  async getSubscriptions(){
    if (this.user) {
      let loading = await this.loadingCtrl.create({});
      loading.present();

      this.rest._get('subscription/purchased/list').subscribe(async (response) => {
        const res: any = response.body;
        this.userSubscriptions = res;

        if (this.userSubscriptions && this.userSubscriptions.length && this.userSubscriptions[0].due_date){
          this.due_date = (new Date(this.userSubscriptions[0].due_date)).toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
        }

        if (this.user.msisdn !== null && this.user.msisdn != 'louderband' && this.user.has_courses) {
          this.showSubscribe = false;
        }

        console.log('purchased subscriptions', res);
        loading.dismiss();

      }, (error) => {
        loading.dismiss();
        console.error('error subscriptions: ', error);
      });
    }

    this.getAvailableSubscriptions();
  }

  async optionUnSubscribe(subscription){
    console.log(subscription);

    let loading = await this.loadingCtrl.create({});

    const alert = await this.alertCtrl.create({
      header: 'Alert',
      cssClass: 'custom-alert',
      message: '¿Confirmas que deseas darte de baja?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'OK',
          role: 'confirm',
          handler: () => {
            loading.present();

            var body = {
              'subscription_purchased_id': subscription
            };

            this.rest._post('subscription/unsubscribe', body).subscribe(async (response) => {
              const res: any = response.body;
              console.log('unsubscribe', res);
              loading.dismiss();

              const toast = await this.toastCtrl.create({
                message: 'Recibimos tu solicitud de darte de baja, en breve tu desuscripción será procesada',
                duration: 3000,
                position: 'middle'
              });

              await toast.present();

              this.getSubscriptions();
            }, async (error) => {
              loading.dismiss();
              console.error('error: ', error);

              const toast = await this.toastCtrl.create({
                message: 'Ocurrió un error al darte de baja. Contacta a atención al cliente para mas detalles.',
                duration: 3000,
                position: 'middle'
              });

              await toast.present();
            });
          },
        },
      ],
    });

    await alert.present();
  }

  goToPaymentGateway(res, type: 'buy' | 'gift') {
    let valsend = res.paymentUrl;
    console.log('open ' + valsend);
    window.open(encodeURI(valsend), '_self');
  }

  buySubscriptionWithOut(loader, aux) {
    aux.to = this.futureEmail;
    aux.force_web_price = 1;

    this.rest._post('subscription/guest/purchase', aux).subscribe(async res => {
      if (res) {
        loader.dismiss();
        const toast = await this.toastCtrl.create({
          message: 'Continua con el pago',
          duration: 2000,
          position: 'middle'
        });
        await toast.present();
        this.goToPaymentGateway(res.body, 'buy');
      }
    }, async (error) => {
      const toast = await this.toastCtrl.create({
        message: error.error.error,
        duration: 2000,
        position: 'middle'
      });
      await toast.present();
      loader.dismiss();
    });
  }

  buySubscriptionNormal(loader, aux) {
    aux.force_web_price = 1;

    this.rest._post('subscription/purchase', aux).subscribe(async res => {
      if (res) {
        loader.dismiss();
        const toast = await this.toastCtrl.create({
          message: 'Continua con el pago',
          duration: 2000,
          position: 'middle'
        });
        await toast.present();
        this.goToPaymentGateway(res.body, 'buy');
      }
    }, async (error) => {
      const toast = await this.toastCtrl.create({
        message: error.error.error,
        duration: 2000,
        position: 'middle'
      });
      await toast.present();
      loader.dismiss();
    });
  }

  async subscribe() {
    const loader = await this.loadingCtrl.create({});
    let aux: any = {
      subscription: this.availableSubscriptions[0].id,
      force_web_price: 1,
      url_coupon_code: this.refCode,
      email: this.user?.email
    };
    if (this.coupon) {
      aux.coupon = this.coupon.coupon_id
    }
    if (this.user != null && (this.user.premium === 'S' || 'N')) {
      loader.present();
      this.buySubscriptionNormal(loader, aux);
    } else {
      this.buySubscriptionWithOut(loader, aux);
    }
  }

  async optionSubscribe() {
    let auxBoolean = true;

    if (this.user != null) {
      auxBoolean = false;
    }

    const popover = await this.popoverCtrl.create({
      component: OptionSubscribeComponent,
      componentProps: { notAccount: auxBoolean, subscriptionId: this.availableSubscriptions[0].id },
      mode: 'ios',
      cssClass: 'pop-option-buy'
    });

    await popover.present();

    const { data } = await popover.onDidDismiss();

    console.log(data);

    if (data) {
      if (data.coupon) {
        this.coupon = data.coupon;
      }
      if (auxBoolean && data.futureEmail) {
        this.futureEmail = data.futureEmail;
      }

      if (data.value == 'buy') {
        this.subscribe();
      }
    };
  }

  detectOnLoad(e) {
    console.log('iFrame load:', e.contentWindow);
    console.log('iFrame load:', e.contentWindow.location);
    console.log('iFrame load:', e.src);

    const capture = ['https://louderband.com/cursos?type=2', 'https://louderband.com/suscripciones'];

    if (capture.includes(e.contentWindow.location.href)){

      const givenUrl = e.contentWindow.location.href;
      const clearUrl = givenUrl.replace('https://louderband.com/', '');
      // this.location.go(clearUrl);
      this.navCtrl.navigateForward(clearUrl);
    }
  }
}
